const authorizeToken = {
  headers: {
    Authorization: "Bearer " + process.env.REACT_APP_TOKEN,
  },
};

export default authorizeToken;
